import TYPES from '@/types';
import Vue from 'vue';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import { Values } from '@/modules/shared/domain/i18n/types';
import Translator from '@/modules/shared/domain/i18n/translator';

export default class AccessMoreStrategiesModerateHiringViewModel {
  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  readonly i18n_namespace = 'components.strategy-moderate-wealth.strategy-moderate-hiring-flow';

  readonly STEPS = [
    {
      step: 0,
      component: 'StrategyInformationAndVideo',
    },
    {
      step: 1,
      component: 'StrategyComparisonPesosAndModerate',
    },
    {
      step: 4,
      component: 'StrategyHiring',
    },
    {
      step: 5,
      component: 'StrategyTransfer',
    },
    {
      step: 6,
      component: 'StrategyRequestSent',
    },
  ];

  current_step = 0;

  current_header_step = 1;

  final_step = this.STEPS.length - 1;

  current_component = this.STEPS[this.current_step];

  width_percent = '60%';

  private readonly view: Vue;

  public constructor(view: Vue) {
    this.view = view;
  }

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  menu_steps = this.translate('header_steps');

  get dynamic_width() {
    // eslint-disable-next-line no-nested-ternary
    return (this.view.$vuetify.breakpoint.xs) ? '100%' : (this.view.$vuetify.breakpoint.sm) ? '80%' : this.width_percent;
  }

  get show_stepper_header() {
    return this.current_step > 3 && this.current_step < 6;
  }

  setDynamicWidth = (width: number) => {
    this.width_percent = `${width}%`;
  }

  nextStep = async () => {
    if (this.current_step === this.final_step) {
      this.endProcess();
      return;
    }

    if (this.current_step < this.final_step) {
      this.current_step += 1;
      this.current_component = this.STEPS[this.current_step];
    }

    if (this.current_step > 4) {
      this.current_header_step += 1;
    }
  }

  prevStep = () => {
    if (this.current_step === 0) {
      this.endProcess();
      this.view.$emit('backToProductInformation');
      return;
    }

    if (this.current_step > 0) {
      this.current_step -= 1;
      this.current_component = this.STEPS[this.current_step];
    }

    if (this.current_step >= 4) {
      this.current_header_step -= 1;
    }
  }

  endProcess = () => {
    this.current_step = 0;
    this.current_header_step = 1;
    this.current_component = this.STEPS[this.current_step];
  }
}
